import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const DashboardIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <rect width="40" height="40" rx="4" fill="#EBF8FF" />
    <path
      d="M22.4016 9.33203H17.6016V30.932H22.4016V9.33203Z"
      stroke="#00060F"
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
      strokeLinejoin="round"
    />
    <path
      d="M32.0012 15.332H27.2012V30.932H32.0012V15.332Z"
      stroke="#00060F"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8 21.332H8V30.932H12.8V21.332Z"
      stroke="#00060F"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
export default DashboardIcon;
